export namespace DevicePairing {
  export const StorageTokenKeyPrefix: string = 'mbg:token:dpair:';
  export const StorageGeoTrackingKeyPrefix: string = 'mbg:token:geotracking:';
}
